// extracted by mini-css-extract-plugin
module.exports = {"root":"InstallPrompt_root_2El-U","close":"InstallPrompt_close_Olp-G","title":"InstallPrompt_title_13nwN","message":"InstallPrompt_message_3Q4Uh"};